module.exports = __webpack_public_path__ + "img/info1.98c50b22.png";